'use strict';

module.exports = function () {
    $('body').on('mouseenter', '.product-tile', function () {
        if ($(window).width() > 1023) {
            $(this).find('.quickview').removeClass('invisible');
        }
    });

    $('body').on('mouseleave', '.product-tile', function () {
        $(this).find('.quickview').addClass('invisible');
    });
};
